import InboxPage from "@/components/admin/InboxPage";

export default function PesanMasuk() {
  return <InboxPage title="Pesan Masuk" subtitle="Pesan & pertanyaan dari form kontak website" endpoint="messages" prefix="admin-pesan" emptyText="Belum ada pesan masuk." />;
}
